<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theSearchQttId' clearable @change="theSearchQttIdChange" size="small">
          <el-option v-for="item in getQuestionTopicTypeList_data.data || []" :key="item.qttId" :label="item.qttName"
            :value="item.qttId">
          </el-option>
        </el-select>
        <el-select v-model='getQuestionTopicList_data.qtgId' clearable @change="getList" size="small">
          <el-option v-for="item in getQuestionTopicGroupList_data.data || []" :key="item.qtgId" :label="item.qtgName"
            :value="item.qtgId">
          </el-option>
        </el-select>
        <el-select v-model='getQuestionTopicList_data.qtcId' clearable @change="getList2" size="small">
          <el-option v-for="item in getQuestionTopicClassList_data.data || []" :key="item.qtcId" :label="item.qtcName"
            :value="item.qtcId">
          </el-option>
        </el-select>
        <el-input v-model="getQuestionTopicList_data.qtName" placeholder="请输入试题名" clearable size='small'
          style="max-width:380px;margin-left:15px;" />
        <el-button v-click.getQuestionTopicList type="primary" icon='el-icon-search' size='small'
          style='margin-left:15px;'>搜索
        </el-button>
        <el-button v-if="uploadQuestionTopic" @click=" $form('uploadQuestionTopic'), tabledataAll = [], row = {}"
          size='small' type="primary" style="float:right;margin-right: 20px;" icon='el-icon-circle-plus'>批量导入
        </el-button>
      </el-col>
      <el-col :span="6">
        <el-button v-if="addQuestionTopic" @click=" $form('addQuestionTopic')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加试题
        </el-button>
      </el-col>
    </el-row>
    <myform view.uploadQuestionTopic="批量导入" @close='$form("uploadQuestionTopic", "hide")'>
      <el-row>
        <el-col :span="4" style="min-width:100px;">
          <el-button type="primary" @click="toDownExcel">下载<i class="el-icon-download el-icon--right"></i></el-button>
        </el-col>
        <el-col :span="20">
          <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
            :on-change="onChangeContent">
            <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
        <el-table-column prop="status" label="状态" width="120">
        </el-table-column>
        <el-table-column prop="statusMsg" label="原因" width="120">
        </el-table-column>
        <el-table-column prop="qttName" label="试题类型">
        </el-table-column>
        <el-table-column prop="qtgName" label="题目分组">
        </el-table-column>
        <el-table-column prop="qtName" label="题目名称">
        </el-table-column>
        <el-table-column prop="qtcName" label="题目分类">
        </el-table-column>
        <el-table-column prop="btName" label="业务类型">
        </el-table-column>
        <el-table-column prop="itemOne" label="选项一">
        </el-table-column>
        <el-table-column prop="itemTwo" label="选项二">
        </el-table-column>
        <el-table-column prop="itemThree" label="选项三">
        </el-table-column>
        <el-table-column prop="itemFour" label="选项四">
        </el-table-column>
      </el-table>
      <!-- <div style="width:100%; margin: 60px auto 20px;text-align: right;">
                <el-button @click="bulkImportClose">取 消</el-button>
                <el-button type="success" @click="bulkImportClick">确定导入</el-button>
            </div> -->
    </myform>
    <mytable :tableColums='tableColums_getQuestionTopicList' api='getQuestionTopicList' xupdateapi='updateQuestionTopic'
      :height="H - 165">
    </mytable>

    <myform :viewobj='{
      addQuestionTopic: ["新增试题信息", "el-icon-circle-plus"],
      updateQuestionTopic: ["修改试题信息", "el-icon-edit-outline"],
      $succeed$: getQuestionTopicList
    }'
      @close='$form("addQuestionTopic", "reset"); window.sleep(50, v => array = [{ qtiValue: "A.", qtiIsAnswer: 1, id: 1 }], theQttId = "",)'
      @confirm='myform'>
      <hide slot='qtId' />
      <hide slot='questionTopicItemListString' />
      <template v-slot:qttId="{ Myformdata }">
        <el-select v-model='Myformdata.qttId' clearable @change="qttIdChange" filterable>
          <el-option v-for="item in getQuestionTopicTypeList_data.data || []" :key="item.qttId" :label="item.qttName"
            :value="item.qttId" @click.native="Myformdata.qtScore = item.qttScoreDefault">
          </el-option>
        </el-select>
      </template>
      <template v-slot:qtgId="{ Myformdata }">
        <el-select v-model='Myformdata.qtgId' clearable filterable>
          <el-option v-for="item in getQuestionTopicGroupList_data.data || []" :key="item.qtgId" :label="item.qtgName"
            :value="item.qtgId">
          </el-option>
        </el-select>
      </template>
      <template v-slot:qtcId="{ Myformdata }">
        <el-select v-model='Myformdata.qtcId' clearable filterable>
          <el-option v-for="item in getQuestionTopicClassList_data.data || []" :key="item.qtcId" :label="item.qtcName"
            :value="item.qtcId">
          </el-option>
        </el-select>
      </template>
      <template v-slot:qtNameImage="{ Myformdata }">
        <myupload v-event.fileUpload='`
                      return (Myformdata.qtNameImage+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.qtNameImage = C : false )
                    `' @change='Myformdata.qtNameImage = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.qtNameImage = "")' type='image' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.qtNameImage && Myformdata.qtNameImage != ' '
            ? ({ name: Myformdata.qtNameImage, url: Myformdata.qtNameImage })
            : false"
          :style="{ height: Myformdata.qtNameImage && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <!-- <template v-slot:btId="{Myformdata}" >
        <el-select v-model='Myformdata.btId' clearable>
            <el-option
                v-for="item in getBusinessTypeList_data.data||[]"
                :key="item.btId"
                :label="item.btName"
                :value="item.btId">
            </el-option>
        </el-select>
  	  </template> -->
      <template v-slot:qtScore="{ Myformdata }">
        <el-input v-model="Myformdata.qtScore" type="number" :min="1" :max="100"></el-input>
      </template>
      <!-- 单选 -->
      <template v-if="theQttId == 1">
        <el-button style="margin-left:50px;" type="primary" round size="small" class="el-icon-circle-plus"
          @click="toAddArray">
          添加
        </el-button>
        <el-table :data="array" border highlight-current-row :header-cell-style="$$headerStyle"
          style="width: 90%;margin:12px 0 0 50px;">
          <el-table-column type="index" label="单选" align="center" width="80">
            <template slot-scope="scope">
              <el-radio v-model="currentRowId" :label="scope.row.id"
                @change="changeRadio($event, scope.row)">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="内容" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.qtiValue" size="medium" style="padding:7px;"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="small" round class="el-icon-delete"
                @click="toDeleteArray(scope.$index, scope.row)"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 判断 -->
      <template v-if="theQttId == 3">
        <el-button style="margin-left:50px;" type="primary" round size="small" class="el-icon-circle-plus"
          @click="toAddArray">
          添加
        </el-button>
        <el-table :data="array" border highlight-current-row :header-cell-style="$$headerStyle"
          style="width: 90%;margin:12px 0 0 50px;">
          <el-table-column type="index" label="判断" align="center" width="80">
            <template slot-scope="scope">
              <el-radio v-model="currentRowId" :label="scope.row.id"
                @change="changeRadio($event, scope.row)">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="内容" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.qtiValue" size="medium" style="padding:7px;"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="small" round class="el-icon-delete"
                @click="toDeleteArray(scope.$index, scope.row)"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 多选 -->
      <template v-if="theQttId == 2">
        <el-button style="margin-left:50px;" type="primary" round size="small" class="el-icon-circle-plus"
          @click="toAddArray">
          添加
        </el-button>
        <el-table :data="array" border highlight-current-row :header-cell-style="$$headerStyle"
          style="width: 90%;margin:12px 0 0 50px;" ref="multipleTables" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="80" label="多选" key="selection"></el-table-column>
          <el-table-column label="内容" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.qtiValue" size="medium" style="padding:7px;"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="small" round class="el-icon-delete"
                @click="toDeleteArray(scope.$index, scope.row)"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 填空 -->
      <template v-if="theQttId == 4">
        <el-input style="width: 90%;margin-left:50px;" v-model="theAnswer" placeholder="请输入答案"></el-input>
      </template>
      <!-- 简答 -->
      <template v-if="theQttId == 5">
        <div style="margin: 20px;width: 210px;text-align: center;">
          简答题关键词
        </div>
        <el-input style="width: 90%;margin-left:50px;" type="textarea" :rows="4" v-model="theKeys"
          placeholder="请输入简答题关键词"></el-input>
        <el-input style="width: 90%;margin-left:50px;" type="textarea" :rows="4" v-model="theAnswer"
          placeholder="请输入答案"></el-input>
      </template>
    </myform>

    <myform view.lookQuestionTopic='查看详情' @opened="form => form.title += ' | @' + row.qtName">
      <div v-if="row.qtName">
        <div>试题类型 : {{ row.qttName }}</div>
        <div>题目名称 : {{ row.qtName }}</div>
        <div>业务类型 : {{ row.btName }}</div>
        <div>创建时间 : {{ row.createtime }}</div>
        <div>题干图片 : <img :src="row.qtNameImage" style='width:200px;' /></div>
        <div>解析 : {{ row.qtAnalysis }}</div>
        <div>选项答案 :</div>
        <div v-for="item in row.questionTopicItemList" :key="item.qtiId">
          <div v-if="item.qttId == 5" style="margin: 20px;"><span style="color: red;">关键词</span>{{ item.qtiKeys }}</div>
          <span v-if="item.qtiIsAnswer == 2" style="color:green;">{{ item.qtiValue }}</span>
          <span v-else>{{ item.qtiValue }}</span>
        </div>
      </div>
      <hide slot='customId' />
    </myform>
  </div>
</template>

<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      tabledataAll: [],
      theKeys: '',
      theAnswerId: '',
      row: { qtName: "1" },
      attrId: null,
      array: [
        { qtiValue: "A.", qtiIsAnswer: 1, id: 1 },
      ],
      currentRowId: 1,
      currentRowIdMulti: 1,
      theQttId: "",//单选题  多选题  判断题  填空题  简答题
      theSearchQttId: "",//单选题  多选题  判断题  填空题  简答题
      theAnswer: "",//填空,简答的答案
      tableColums_getQuestionTopicList: {
        $selection: false,

        qttName: '试题类型',

        qtName: '题目名称',
        qtgName: '题目分组',
        qtcName: '题目分类',
        btName: '业务类型',


        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.getQuestionTopicList && `@text: 预览#success
           @click: $form("lookQuestionTopic", $this.row = $row)
          `,
          this.updateQuestionTopic && `@text: 编辑#success
           @click: toEdit($row)
          `,
          this.deleteQuestionTopic && `@text: 删除#danger
           @click: _confirm('确定要删除该试题吗?')
                   .trigger('deleteQuestionTopic',{qtId:$row.qtId})
                   .trigger('getQuestionTopicList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    doupload: async function (file) {
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      if (this.row && this.row.projectId) {
        param.append("projectId", this.row.projectId);
      }
      console.log(param)
      const loading = $Loading();
      const responseData = await myhttp.postFileUsers("/opportunity/question-topic/uploadQuestionTopic", param);
      loading.close();
      if (responseData.data.result == "success") {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
      } else {
        this.$message({
          type: "error",
          message: "上传失败!"
        });
      }
      return responseData
    },
    async onChangeContent(files, fileList) {
      const table = await this.doupload(files.raw);
      console.log(table);

      this.tabledata = table.data.data;
      this.tabledataAll = table.data.data;
      //    this.getUserTargetList();
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();  //清空文件
      }
      if (this.$refs.uploadAll) {
        this.$refs.uploadAll.clearFiles();  //清空文件
      }
    },
    toDownExcel() {
      myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/questiontopic.xlsx", "题库.xlsx");
    },
    theSearchQttIdChange(event, row) {
      this.theSearchQttId = event;
      this.getQuestionTopicList({ qttId: this.theSearchQttId });
    },
    getList(e) {
      this.getQuestionTopicList({ qtgId: e });
    },
    getList2(e) {
      this.getQuestionTopicList({ qtcId: e });
    },
    changeRadio(event, row) {
      this.currentRowId = event;
      this.array.forEach((item, index) => {
        if (item.id != this.currentRowId) {
          item.qtiIsAnswer = 1
        }
      })
      console.log(event, row);
    },
    handleSelectionChange(val) {
      this.currentRowIdMulti = val;
    },
    toAddArray() {
      if (this.theQttId == 3 && this.array.length >= 2) {
        this.$message({
          message: '不能再添加了',
          type: 'warning'
        });
        return;
      }
      if (this.theQttId == 3) {
        this.array.push({ qtiValue: "错", qtiIsAnswer: 1, id: 2 });
        return;
      }
      this.array.push({ qtiValue: "", qtiIsAnswer: 1, id: this.array.length + 1 });
    },
    async qttIdChange(e) {
      this.theQttId = '';
      await this.$nextTick();
      this.theQttId = e;

      if (e == 3) {
        this.array = [{ qtiValue: "对", qtiIsAnswer: 1, id: 1 }]
      } else if (e == 1 || e == 2) {
        this.array = [{ qtiValue: "A.", qtiIsAnswer: 1, id: 1 }]
      }
    },
    toDeleteArray(index, row) {
      if (this.array.length == 1) {
        return;
      }
      this.array.splice(index, 1);
    },
    toEdit(row) {

      // this.getBusinessTypeList();
      this.theQttId = row.qttId;
      switch (this.theQttId) {
        case 1:
        case 3:
          //单选题 判断题 
          this.array = row.questionTopicItemList;
          //设置选中
          this.array.forEach((element, index) => {
            element.id = element.qtiId;
            if (element.qtiIsAnswer == 2) {
              element.qtiIsAnswer = 2
              this.currentRowId = element.id
            }
          });
          break;
        case 2:
          //多选题 
          this.theQttId = 2
          this.array = row.questionTopicItemList;
          //设置选中
          this.$nextTick(() => {
            this.array.forEach((element, index) => {
              element.id = index + 1;
              if (element.qtiIsAnswer == 2) {
                element.qtiIsAnswer = 2
                this.$refs.multipleTables.toggleRowSelection(this.array[index], true);//默认选中
              } else {
                element.qtiIsAnswer = 1
              }
            });
          })
          break;
        case 4:
        case 5:
          //填空题  简答题
          this.theAnswer = row.questionTopicItemList[0].qtiValue;
          this.theAnswerId = row.questionTopicItemList[0].qtiId;
          this.theKeys = row.questionTopicItemList[0].qtiKeys;
          break;
      }
      this.$form("updateQuestionTopic", row);
    },
   async myform(submit, Myformdata) {
      // 单选题  多选题  判断题  填空题  简答题
      switch (this.theQttId) {
        case 1:
        case 3:
          this.array.forEach(element => {
            if (element.id == this.currentRowId) {
              element.qtiIsAnswer = 2
            }
            if (element.qtiValue == null || element.qtiValue == '') {
              this.$message({
                message: '选项不能为空',
                type: 'warning'
              });
            }
          });
          break;
        case 2:
          //多选
          this.array.forEach(element => {
            if (element.qtiValue == null || element.qtiValue == '') {
              this.$message({
                message: '选项不能为空',
                type: 'warning'
              });
            }
            element.qtiIsAnswer = 1
            this.currentRowIdMulti.forEach(item => {

              //设置答案
              if (element.id == item.id) {
                element.qtiIsAnswer = 2
              }
            });
          });
          break;
        case 4:
        case 5:
          this.array = [{ qtiValue: this.theAnswer, qtiIsAnswer: 2, qtiId: this.theAnswerId, qtiKeys: this.theKeys }];
          break;
      }

      Myformdata.questionTopicItemListString = JSON.stringify(this.array);
      const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))

    },
    async sub(submit) {
      this.$nextTick(() => {

      })
      submit();
    },
  },

  created() {
    this.getQuestionTopicList({ qttId: this.theSearchQttId });
    this.getQuestionTopicTypeList();
    this.getQuestionTopicClassList();
    this.getQuestionTopicGroupList();

  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/paper/PaperTopicManage.vue